import { apartment, awapShare, educator, moneybag } from '@/assets';

export const Investments = () => {
  return (
    <div className='px-8 md:p-8'>
      <h2 className='text-lg font-semibold text-center mb-8 text-transform: uppercase'>
        WHAT WE OFFER
      </h2>

      <div className='flex flex-col sm:flex-row sm:min-h-[30vh] px-4 sm:px-16 py-8 bg-[#D2FFDC] mb-8 rounded-md'>
        <div className='flex-1 sm:flex-[0.4]'>
          <img alt='real estate' src={apartment} className='h-[150px]' />
        </div>
        <div className='flex-1 sm:flex-[0.6]'>
          <h3 className='font-medium text-lg mb-2'>REAL ESTATE MARKET</h3>
          <p>
            Discover premium real estate opportunities through our digital
            marketplace. Buy, sell, and invest in carefully selected properties
            with the convenience of managing your investments from anywhere.
            Build lasting wealth through secure and value-driven real estate
            investments.
          </p>
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:min-h-[30vh] px-4 sm:px-16 py-8 bg-[#FFF9E2] mb-8 rounded-md'>
        <div className='flex-[0.4]'>
          <img alt='project slots' src={moneybag} className='h-[150px]' />
        </div>
        <div className='flex-[0.6]'>
          <h3 className='font-medium text-lg mb-2'>AWAP PROJECT SLOT - APS</h3>
          <p>
            Invest directly in carefully selected, high-potential physical
            projects with strong growth prospects. Each Project Slot is attached
            to a specific real-life project with a defined duration and
            appreciation rate, allowing you to participate in its success and
            earn structured, project-based returns while building long-term
            wealth.
          </p>
        </div>
      </div>

      <div className='flex flex-col-reverse sm:flex-row sm:min-h-[30vh] px-4 sm:px-16 py-8 bg-[#E7EFC7] mb-8 rounded-md'>
        <div className='flex-1 sm:flex-[0.6]'>
          <h3 className='font-medium text-lg mb-2'>AWAP PROJECT UNIT - APU</h3>
          <p>
            Acquire Awap Project Units in our proprietary Digital Asset Market
            and benefit from our structured 5% monthly appreciation model. Unit
            values are evaluated from the net profit made from Project Slots
            upon each project completion. Investors enjoy liquidity and
            flexibility, with the freedom to buy or sell their Project Units in
            the market at any time.
          </p>
        </div>
        <div className='flex flex-[0.4] justify-end p-8'>
          <img
            alt='project units'
            src={awapShare}
            className='-mt-[55px] h-[150px]'
          />
        </div>
      </div>

      <div className='flex flex-col-reverse sm:flex-row sm:min-h-[30vh] px-4 sm:px-16 py-8 bg-[#FFF2EB] mb-8 rounded-md'>
        <div className='flex-1 sm:flex-[0.6]'>
          <h3 className='font-medium text-lg mb-2'>LAND PAY</h3>
          <p>
            Own your preferred land through convenient weekly payments spread
            over one year. Our Land Pay facility allows you to gradually pay for
            your land in affordable installments while securing your purchase,
            making land ownership simple, flexible, and accessible.
          </p>
        </div>
        <div className='flex flex-[0.4] justify-end p-8'>
          <img alt='land pay' src={educator} className='-mt-[55px] h-[150px]' />
        </div>
      </div>

      <div className='flex flex-col sm:min-h-[30vh] px-4 sm:px-16 py-8 bg-[#EDE9FE] mb-8 rounded-md'>
        <h3 className='font-medium text-lg mb-2'>BECOME AN E-REALTOR</h3>
        <p>
          Join our E-Realtor network with a one-time activation fee of ₦10,000
          and gain access to the company&apos;s Builders Reward System (BRS).
        </p>
        <p className='mt-4 font-medium'>As an E-Realtor, you can earn:</p>
        <ul className='mt-2 space-y-1'>
          <li>🔯 8% Sales Commission from the Real Estate Market</li>
          <li>🔯 ₦30,000 worth of Project Units as a Builders Bonus</li>
          <li>🔯 8% Referral Bonus on Project Slots and Project Units</li>
          <li>🔯 2% Team Bonus on Project Slots and Project Units</li>
          <li>🔯 Networkers&apos; Ranks & Incentives based on NetPoints</li>
        </ul>
        <p className='mt-4 font-semibold'>LIFETIME E-REALTOR BENEFITS</p>
      </div>
    </div>
  );
};
